import styled from '@mui/material/styles/styled';
import Typography from '@mui/material/Typography';

const StyledBoldTypography = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
}));

export default StyledBoldTypography;
